// project import
import other from './other';
import configuration from './configuration';

// types
import { NavItemType } from 'types';
import interventionPlan from './interventionPlan';
import maintenance from './maintenance';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
    items: [other, configuration, interventionPlan, maintenance]
};

export default menuItems;
